import Paper from '@material-ui/core/Paper';
import { RouteComponentProps } from '@reach/router';
import React, { Component } from 'react';
import ReactMarkdown from 'react-markdown';
import { withContext } from '../../../contrib/utils';
import { IPagesStore } from '../../../store/pages/store';
import { IClubsActions } from '../../../store/player/clubs/actions';
import { IClubsStore } from '../../../store/player/clubs/store';

interface IProps extends RouteComponentProps {
  actions: {
    clubs: IClubsActions;
  };
  clubId: string;
  slug: string;
  pages: IPagesStore;
  clubs: IClubsStore;
}

class ClubPagesComponent extends Component<IProps, {}> {
  public componentDidMount(): void {
    this.props.actions.clubs.get(Number(this.props.clubId));
  }

  public render(): JSX.Element {
    const { clubId, pages, slug, clubs } = this.props;

    const page = (pages[Number(clubId)] || []).find(p => p.id === Number(slug));

    const title = page ? page.name : 'Not Found';
    const content = page ? page.content : 'Page Under Construction';

    const club = clubs && clubs[Number(this.props.clubId)];
    const style =
      club && club.backgroundImage
        ? {
            backgroundImage: `url(${club.backgroundImage})`,
            backgroundPosition: '50%',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover'
          }
        : {};

    return (
      <div className="home club-home wrapper">
        <div>
          <div className={'main-title'} style={style}>
            <div className="mask" />
            <h2>{title}</h2>
          </div>
          <Paper elevation={1} className="page-content">
            <ReactMarkdown source={content} className="markdown" />
          </Paper>
        </div>
      </div>
    );
  }
}

const ClubPages = withContext(ClubPagesComponent, 'notifications', 'pages', 'clubs');

export { ClubPages, ClubPagesComponent };
